/**
 * FlagIcon/index.js
 * desc: message flagged icon
 * note: entity icon via IconButton; defaults its tooltip + accessible name to the
 *       icon label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';
import './styles.css';


const FlagIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="flag icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.flag.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 22 24" xmlns="http://www.w3.org/2000/svg"><path d="M13.27 2.824L12.707 0H0v24h2.824v-9.882h7.905l.565 2.823h9.883V2.824H13.27z"/></svg>
    </IconButton>
);


export default FlagIcon;
